import axiosInstance from './axiosInstance'

/**
 * Fetch aggregated statistics for the dashboard.
 * Returns { demandCount, supplyCount, syncAccuracy, activeYear }.
 */
export async function getDashboardStats(year) {
  try {
    const params = year ? { year } : {}
    const response = await axiosInstance.get('/api/dashboard/stats', { params })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data || error.message || 'Failed to fetch dashboard stats'
    console.error('Dashboard Stats Error:', errorMessage)
    return {
      demandCount: 0,
      supplyCount: 0,
      syncAccuracy: 0,
      activeYear: year || '2025'
    }
  }
}

/**
 * Fetch workforce gap analysis comparing demand and supply by cluster.
 * Returns List<{ cluster, demandTotal, supplyTotal, gap, gapPercent }>.
 */
export async function getGapAnalysis(year) {
  try {
    const params = year ? { year } : {}
    const response = await axiosInstance.get('/api/dashboard/gap-analysis', { params })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data || error.message || 'Failed to fetch gap analysis'
    console.error('Gap Analysis Error:', errorMessage)
    return []
  }
}
